import { Route, Routes } from "react-router";
import HomeScreen from "./screens/homeScreen";
import { RestaurantSelectionPage } from "./components/RestaurantSelectionPage";
import { useEffect, useMemo, useState } from "react";
import { HomePage } from "./components/HomePage";
import {
  Drawer,
  DrawerClose,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "./components/ui/drawer";
import { DrawerContent } from "./components/ui/drawer";
import Lottie from "lottie-react";
import phoneAnimation from "@/assets/phone.json";
import { Button } from "./components/ui/button";
import Layout from "./components/Layout";
import PopularItemsScreen from "./screens/popularItemsScreen";
import SearchResultsScreen from "./screens/searchResultsScreen";
import { useTranslation } from "react-i18next";
import NewItemsScreen from "./screens/newItemsScreen";
import CheckoutScreen from "./screens/checkoutScreen";
import { Toaster } from "react-hot-toast";
import OrdersScreen from "./screens/ordersScreen";
import FavouritesScreen from "./screens/favouritesScreen";
import ProfileScreen from "./screens/profileScreen";
import AiScreen from "./screens/aiScreen";
import PrivacyPolicyScreen from "./screens/privacyPolicyScreen";
import Test from "./Test";

export default function App() {
  const [downloadAppDrawerOpen, setDownloadAppDrawerOpen] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (
      isMobile &&
      location.pathname.startsWith("/ai/mobile") &&
      location.pathname.startsWith("/ai/test")
    ) {
      setDownloadAppDrawerOpen(true);
    }
  }, []);

  const appLink = useMemo(() => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return "https://play.google.com/store/apps/details?id=com.kaman.user";
    }
    return "https://apps.apple.com/il/app/kaman/id6751156694";
  }, []);
  return (
    <div
      dir={i18n.dir()}
      className={`h-full ${
        i18n.language === "ar"
          ? "font-arabic"
          : i18n.language === "he"
          ? "font-hebrew"
          : "font-english"
      }`}
    >
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomeScreen />} />
          <Route path="/categories/:categoryId" element={<HomeScreen />} />
          <Route
            path="/main-categories/:mainCategoryId"
            element={<HomeScreen />}
          />
          <Route path="/restaurants" element={<RestaurantSelectionPage />} />
          <Route path="/restaurants/:restaurantId" element={<HomePage />} />
          <Route
            path="/restaurants/:restaurantId/items/:itemId"
            element={<HomePage />}
          />
          <Route path="/popular-items" element={<PopularItemsScreen />} />
          <Route path="/search" element={<SearchResultsScreen />} />
          <Route path="/popular-items" element={<PopularItemsScreen />} />
          <Route path="/new-items" element={<NewItemsScreen />} />
          <Route path="/checkout" element={<CheckoutScreen />} />
          <Route path="/orders" element={<OrdersScreen />} />
          <Route path="/favourites" element={<FavouritesScreen />} />
          <Route path="/profile" element={<ProfileScreen />} />
          <Route path="/ai" element={<AiScreen />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyScreen />} />
        </Route>
        <Route path="/ai/mobile/:lang" element={<AiScreen eventsOnly />} />
        <Route path="/ai/test" element={<Test />} />
      </Routes>

      {/* <Toaster richColors /> */}
      <Toaster />

      <Drawer open={downloadAppDrawerOpen} dismissible>
        {/* Drawer Content */}
        <DrawerContent className=" p-4 flex flex-col items-center text-center bg-white">
          <DrawerHeader className="flex flex-col items-center space-y-2">
            <DrawerTitle className="text-xl font-semibold">
              Get our App
            </DrawerTitle>
            <DrawerDescription className="text-gray-500">
              For the best experience, download and use our mobile app.
            </DrawerDescription>
          </DrawerHeader>

          {/* Lottie Animation */}
          <div className="w-50 h-50 flex items-center justify-center mb-4 mt-[-24px]">
            <Lottie
              animationData={phoneAnimation}
              loop={true}
              className="w-full h-full"
            />
          </div>

          {/* Footer Buttons */}
          <DrawerFooter className="flex flex-col space-y-1 w-full">
            <Button
              asChild
              className="w-full p-6 text-lg text-white bg-primary shadow-lg border-b rounded-lg"
            >
              <a href={appLink} target="_blank">
                Open App
              </a>
            </Button>
            <DrawerClose asChild>
              <Button
                variant="outline"
                className="w-full p-6 text-lg"
                onClick={() => setDownloadAppDrawerOpen(false)}
              >
                Maybe later
              </Button>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>

    // <div dir={isRTL ? "rtl" : "ltr"}>

    // </div>
  );
}
